import { Plugin, PluginKey, Transaction } from '@tiptap/pm/state';
import { ReplaceStep } from '@tiptap/pm/transform';

const getInsertedNodes = (transaction: Transaction) => {
    return transaction.steps.flatMap((step) => {
        if (!(step instanceof ReplaceStep)) return [];
        if (step.from !== step.to) return [];

        return step.slice.content.content;
    });
};

/**
 * Tracks when a paste transaction inserts a node of the given type and calls the provided callback.
 */
export const createPasteTrackingPlugin = (nodeName: string, onTrackedPaste: () => void) => {
    return new Plugin({
        key: new PluginKey(`trackPaste-${nodeName}`),
        appendTransaction: (transactions) => {
            if (transactions.length < 2) return null;
            if (!transactions[0].getMeta('paste')) return null;

            const pasteInsertedNode = transactions.slice(1).some((transaction) => {
                const insertedNodes = getInsertedNodes(transaction);
                return insertedNodes.some((node) => node.type.name === nodeName);
            });

            if (!pasteInsertedNode) return null;

            onTrackedPaste();
            return null;
        },
    });
};
